<mat-card class="crud-search-card">
  <mat-card-title i18n="@@type.RefCode">Ref Code</mat-card-title>
  <mat-card-content>
    <form [formGroup]="searchForm">
      <div class="search-section">

        <mat-form-field matTooltip="Domain" [matTooltipDisabled]="disabledTooltip(this.domain)" class="search-filter-wide">
          <mat-label i18n="@@type.RefCode.domain">Domain</mat-label>
          <input matInput [matAutocomplete]="domainAutocomplete" formControlName="domain"
            id="domainFilterAutocompleteInput" [(ngModel)]="domainFilter" (ngModelChange)="domainChanged($event)" #domainFilterInput>
          <mat-autocomplete id="domainAutocomplete" #domainAutocomplete (optionSelected)="domainSelected($event)">
            <mat-option *ngFor="let domain of domainSelectionList | async" [value]="domain">
              {{ domain }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field matTooltip="Code" [matTooltipDisabled]="disabledTooltip(this.code)">
          <mat-label i18n="@@type.RefCode.code">Code</mat-label>
          <input matInput formControlName="code" id="codeFilterInput"              
              (ngModelChange)="codeChanging($event)" [(ngModel)]="codeFilter"              
              (ngModelChange)="codeChanged($event)" #codeFilterInput              
              maxlength="64" placeholder="Code">
        </mat-form-field>  


        <mat-form-field matTooltip="Meaning" [matTooltipDisabled]="disabledTooltip(this.meaning)">
          <mat-label i18n="@@type.RefCode.meaning">Meaning</mat-label>
          <input matInput formControlName="meaning" id="meaningFilterInput"              
              (ngModelChange)="meaningChanging($event)" [(ngModel)]="meaningFilter"              
              (ngModelChange)="meaningChanged($event)" #meaningFilterInput              
              maxlength="255" placeholder="Meaning">
        </mat-form-field>  


		<mat-slide-toggle floatLabel="always" appearance="none" color="primary"  *ngIf="autoSearchControlsEnabled"
          [(ngModel)]="autoSearch"  [ngModelOptions]="{standalone: true}">
            Auto Search
        </mat-slide-toggle>

        <button mat-raised-button color="primary" class="action-button" (click)="forceSearch()" type="button"
          i18n="@@actions.search">Search</button>
		  

        <button mat-raised-button color="primary" class="action-button" (click)="clearFilters()" type="button"
          [disabled]="!allowsClearFilters()" i18n="@@actions.clearFilters">Clear Filters</button>
      </div>
			
    </form>

    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort
                           matSortDirection="asc" matSortDisableClear cdkDropList cdkDropListLockAxis="x"
                           cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="code">
            <mat-header-cell [crud-column-header]="columns.column('code')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.RefCode.code">
                Code 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.code}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="domain">
            <mat-header-cell [crud-column-header]="columns.column('domain')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.RefCode.domain">
                Domain 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.domain}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="meaning">
            <mat-header-cell [crud-column-header]="columns.column('meaning')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.RefCode.meaning">
                Meaning 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.meaning}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="val1">
            <mat-header-cell [crud-column-header]="columns.column('val1')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.RefCode.val1">
                Val1 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.val1}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="val2">
            <mat-header-cell [crud-column-header]="columns.column('val2')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.RefCode.val2">
                Val2 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.val2}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit" id="actions.edit">Edit</button>
              <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)" mat-raised-button color="primary"
                [routerLink]="viewRoute(element)" i18n="@@actions.view" id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>

      <button class="action-button" *ngIf="allowsCreate()" mat-raised-button color="primary" [routerLink]="createRoute()"
        [queryParams]="createRouteQueryParams()" i18n="@@actions.create" id="actions.create">Create</button>
      <button class="action-button" *ngIf="allowsBack()" mat-raised-button color="accent" [routerLink]="backRoute()"
        [queryParams]="backRouteQueryParams()" i18n="@@actions.back" id="actions.back">Back</button>
    </div>
  </mat-card-content>
</mat-card>